import { PropsWithChildren, forwardRef } from "react";

export const ToggleGroupItemPadding = forwardRef<
  HTMLDivElement,
  PropsWithChildren
>(function ToggleGroupItemPadding(props, ref) {
  return <div ref={ref} className="px-3 py-2" {...props} />;
});
